var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Success';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Success';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };